import {
  RegisterAndSubscribeToMachineBindingDocument,
  RegisterAndSubscribeToMachineBindingSubscriptionHookResult,
  RegisterAndSubscribeToMachineBindingSubscriptionVariables,
} from '../graphql/generated';
import { useApolloSharedSubscription } from '../subscription/apollo-subscription.manager';
import { MachineRealtimeData } from './binding/binding.types';
export interface MonitorRealtimeDataConfig {
  disabled?: boolean;
}

const useMonitorRealtimeData = (
  id?: string,
  config?: MonitorRealtimeDataConfig
): MachineRealtimeData => {
  const variables: RegisterAndSubscribeToMachineBindingSubscriptionVariables = {
    input: {
      machineId: id as string,
      binding: {
        namespace: 'machine',
        type: 'realtime',
      },
    },
  };

  const { data } =
    useApolloSharedSubscription<RegisterAndSubscribeToMachineBindingSubscriptionHookResult>(
      {
        query: RegisterAndSubscribeToMachineBindingDocument,
        variables,
        subscriptionName: `binding-machine-realtime-${id}`,
        disabled: config?.disabled || id === undefined,
      }
    );

  const result = data?.registerAndSubscribeToMachineBindingResult;

  let realtimeData: MachineRealtimeData = {};
  if (result && result.data) {
    realtimeData = result.data || {};
  }
  return realtimeData;
};

export { useMonitorRealtimeData };
